module.exports = __webpack_public_path__ + "img/home-category-arrow-24x24.f49b9aff.svg";